app.controller(
    'BioCreationController', ['$scope', '$rootScope', '$state', '$stateParams', '$translate', '$window', '$sce', '$timeout', 'BioService', 'HelperService', 'ExplorerService', BioCreationController]
);

function BioCreationController($scope, $rootScope, $state, $stateParams, $translate, $window, $sce, $timeout, BioService, HelperService, ExplorerService) {
    var vm = this;

    vm.BioVm = {};
    vm.ActiveDescriptionVm = {};
    vm.ActiveDescriptionIndex = 0;
    vm.NewDescriptionVm = {};
    var qcCheck = [13601, 13602];//check Credit and Ours only

    $scope.item = {};

    $scope.desc = [
        {
            name: '1',
            position: '1'
        }
    ];

    $scope.current = 1;

    $scope.getCurrent = function (position) {
        $scope.current = position;
        $scope.classificationBoxDesc = false;
        vm.ShowSelectedDesc(position - 1);
        vm.LoadLists();
    };

    $scope.addDescSimple = function () {
        lengthDesc = $scope.desc.length + 1;
        $scope.desc.push({ name: lengthDesc, position: lengthDesc });
        vm.BioVm.DescriptionForCreationVmList.push(angular.copy(vm.NewDescriptionVm));
        $scope.getCurrent(lengthDesc);
    };

    vm.ShowSelectedDesc = function (index) {
        $scope.current = index + 1;
        vm.ActiveDescriptionVm = vm.BioVm.DescriptionForCreationVmList[index];
    }

    $scope.indice = 0;

    $scope.nextDesc = function () {
        if ($scope.indice < $scope.client.length - 1) {
            $scope.indice++;
        }
    };
    $scope.prevDesc = function () {
        if ($scope.indice > 0) {
            $scope.indice--;
        }
    };

    $scope.delDesc = function (elm) {
        $scope.desc.splice(elm, 1);
        if (vm.BioVm.DescriptionForCreationVmList.length > 1) {
            vm.BioVm.DescriptionForCreationVmList.splice(elm, 1);
            for (var i = 0; i < $scope.desc.length; i++) {
                $scope.desc[i].name = (i + 1);
                $scope.desc[i].position = i + 1;
            }
            $scope.getCurrent(1);
        }
    };

    $scope.SelecAll = function (delectAll) {
        for (var i = 0; i < $scope.item.description[0].clients.length; i++) {
            $scope.item.description[0].clients3[i].checked = delectAll;
        }
    };
    $scope.toggleAll = function () {
        angular.forEach($scope.guests, function (itm) {
            console.log(itm);
            itm.selected = $scope.isAllSelected;
        });
    }

    $scope.optionToggled = function () {
        $scope.isAllSelected = $scope.guests.every(function (itm) {
            return itm.selected;
        });
    }

    $scope.newItem = angular.copy($scope.item);

    $scope.contentTranslate = null;

    $scope.item.disaplayName = $scope.item.name || ($scope.item.firstName || $scope.item.lastName);

    /**
     * Liste menu création
     */
    $scope.links = [
        {
            name: 'app.creationGuest.biographie',
            label: 'NouvelleBiographie',
            state: null // edit-valid, valid
        },
        //Hors perimetre: V5
        //{
        //    name: 'app.creationGuest.contacts',
        //    label: 'Contacts & Droits'
        //},

        //Hors perimetre: V5
        //{
        //    name: 'app.creationGuest.infos',
        //    label: 'Infos complémentaires'
        //},
        {
            name: 'app.creationGuest.classification',
            label: 'classification'
        },
        {
            name: 'app.creationGuest.descriptif',
            label: 'descriptif'
        },
        //{
        //    name: 'app.creationGuest.oeuvres',
        //    label: 'Courants & Oeuvres'
        //},
        //{
        //    name: 'app.creationGuest.parcours',
        //    label: 'Parcours'
        //},
        //{
        //    name: 'app.creationGuest.famille',
        //    label: 'Famille'
        //},
        // < !--[Lam Hong 25-Feb-2022] LVCG-63: LVCG-69 [BO INTERFACE] [GUEST CREATION] Remove some UI components -- >
        //{
        //    name: 'app.creationGuest.events',
        //    label: 'ObjetsAssocies'
        //}
        // END
        //{
        //    name: 'app.creationGuest.events',
        //    label: 'Visuel'
        //},
        //{
        //    name: 'app.creationGuest.sources',
        //    label: 'Sources et Commentaires'
        //}
    ];

    $scope.classificationBox = false;
    $scope.classificationBoxDesc = false;
    $scope.placeAndEventBox = false;

    $scope.showOptionsBox = function (item) {
        $scope.classificationBox = true;
        $scope.classificationBoxDesc = false;
        $scope.placeAndEventBox = false;
        $scope.itemSelected = item;
    }

    $scope.showOptionsBoxDesc = function (item) {
        $scope.classificationBox = false;
        $scope.classificationBoxDesc = true;
        $scope.placeAndEventBox = false;
        $scope.itemSelectedDesc = item;
    }

    $scope.showPlaceAndEventBox = function (item) {
        $scope.classificationBox = false;
        $scope.classificationBoxDesc = false;
        $scope.placeAndEventBox = true;
        $scope.itemSelected = item;
    }

    vm.LoadLists = function () {
        $scope.classifications = [
                {
                    name: 'GuideEtoile',
                    items: vm.BioVm.AssociatedZones
                },
                {
                    name: 'supportDeDiffusion',
                    items: vm.BioVm.ClientList
                },
                {
                    name: 'classification',
                    items: vm.BioVm.ParentQualificationList
                },
        ];

        $scope.classificationDesc = [
                {
                    name: 'classification',
                    items: vm.ActiveDescriptionVm.QualificationList
                },
                {
                    name: 'supportDeDiffusion',
                    items: vm.ActiveDescriptionVm.Clients
                }
        ];

        $scope.placeAndEvent = [
                {
                    name: 'nomLieu',
                    items: vm.BioVm.AssociatedPlaces
                }];
    }

    $scope.prevStateUrl = '#';
    $scope.nextStateUrl = '#';
    $scope.currentState = 0;

    angular.forEach($scope.links, function (value, key) {
        if (value.name == $state.current.name) {
            $scope.currentState = key;
            if (key > 0) {
                $scope.prevStateUrl = $scope.links[key - 1].name != '#' ? $state.href($scope.links[key - 1].name) : '#';
            }
            if (key < $scope.links.length - 1) {
                $scope.nextStateUrl = $scope.links[key + 1].name != '#' ? $state.href($scope.links[key + 1].name) : '#';
            }
        }
    });

    $scope.setCurrentState = function (index) {

        index = (index !== 'undefined') ? index : $scope.currentState;

        $scope.currentState = index;
        $scope.prevStateUrl = $scope.links[index - 1] ? ($scope.links[index - 1].name != '#' ? $state.href($scope.links[index - 1].name) : '#') : '#';
        $scope.nextStateUrl = $scope.links[index + 1] ? ($scope.links[index + 1].name != '#' ? $state.href($scope.links[index + 1].name) : '#') : '#';

        $state.go($scope.links[index].name);

        return false;
    };

    $scope.updateState = function (direction) {
        var index = $scope.currentState;
        switch (direction) {
            case -1:
                if (index > 0) {
                    index = $scope.currentState - 1;
                }
                break;

            case +1:
                if (index < $scope.links.length - 1) {
                    index = $scope.currentState + 1;

                }
                break;
        }
        $scope.setCurrentState(index);
    }

    $scope.$on('elastic:resize', function (event, element, oldHeight, newHeight) {
        switch (element.attr("ng-model")) {
            case 'newClient.sousTitreDesc':
            case 'newItem.description[0].sousTitreDesc':
            case 'subtitleTranslate':
                element.parents('.row').find('.block-lecture .sous-titre.desc').css('height', newHeight);
                break;

            case 'newClient.txtDesc':
            case 'newItem.description[0].txtDesc':
            case 'contentTranslate':
                element.parents('.row').find('.block-lecture .text-desc').css('height', newHeight);
                break;
        }
    });

    initController();

    function initController() {
        $translate.use($rootScope.LangForInterface);

        if ($stateParams.qc) {
            vm.ParamQcId = $stateParams.qc;
        }
        else {
            vm.ParamQcId = 10585;
        }

        if ($stateParams.z) {
            vm.ParamZoneId = $stateParams.z;
        }
        else {
            vm.ParamZoneId = $rootScope.DefaultGlobalZoneId;
        }
        vm.RequiredByCreditAndOurs = '';
        if (qcCheck.includes(parseInt(vm.ParamQcId))) {
            vm.RequiredByCreditAndOurs = '*';
        }

        vm.ZoneList = angular.copy($rootScope.ZoneMenuItemList);
        $scope.useCommonCreationTopBar = true;
        $rootScope.getJobList();
        GetBioForCreation(vm.ParamQcId, $rootScope.LangForWork);
    }

    function GetBioForCreation(qc, lang) {
        BioService.GetBioForCreation(qc, lang)
            .then(function (data) {
                vm.BioVm = data;
                vm.GetAssociatedZonesOnSideBar();
                vm.GetPlaceListOfCurrentZone();
                vm.ActiveDescriptionIndex = 0;
                vm.ShowSelectedDesc(vm.ActiveDescriptionIndex);
                vm.BioVm.DescriptionForCreationVmList[0].QualificationList = angular.copy(vm.BioVm.DescriptionQualificationList);
                vm.NewDescriptionVm = angular.copy(vm.BioVm.DescriptionForCreationVmList[0]);
                //$scope.ChangeZoneById(vm.ParamZoneId);
                vm.LoadLists();
            });
    }

    function DataIsValid() {
        var isValid = true;

        if (qcCheck.includes(parseInt(vm.ParamQcId))) {
            //Check ClientList            
            if (CountActiveItems(vm.BioVm.ClientList) == 0) {
                //alert("Diffuseur manqant");
                isValid = false;
            }
            //Check ParentQualificationList
            if (CountActiveItems(vm.BioVm.ParentQualificationList) == 0) {
                //alert("Qualification manqant");
                isValid = false;
            }

            //Check Professional
            if (vm.BioVm.ProfessionTranslation.ProfessionId == 0) {
                //alert("Professionnel manqant");                
                isValid = false;
            }

            //Check Clients of Descriptif
            for (var i = 0; i < vm.BioVm.DescriptionForCreationVmList.length; i++) {
                if (CountActiveItems(vm.BioVm.DescriptionForCreationVmList[i].Clients) == 0) {
                    isValid = false;
                    //alert("Diffuseur de descriptif manqant");
                }
            }
        }
        return isValid;
    }

    $scope.CreateNewObject = function CreateNewBio(redirect) {
        if (DataIsValid()) {
            BioService.CreateNewBio(vm.BioVm)
                .then(
                   function success(data) {
                       if (redirect == true) {
                           $window.location.href = $rootScope.interfaceSubFolder + '/#!/consultation/bio?id=' + data.data + '&lang=' + $rootScope.LangForWork + '&index=0&sortKey=FirstName&reverse=false&z=' + vm.ParamZoneId;
                       }
                       else {
                           $window.location.href = $rootScope.interfaceSubFolder +'/#!/creation/bio/biographie?z=' + vm.ParamZoneId;
                           GetBioForCreation(vm.ParamQcId, $rootScope.LangForWork);
                       }
                   },
                   function error(data) {
                   });
        }
    };

    vm.GetAssociatedZonesOnSideBar = function () {
        HelperService.GetAssociatedZonesOnSideBar(0, $rootScope.EnumLinkType.Bio, $rootScope.LangForWork, true, vm.ParamZoneId)
            .then(function (data) {
                vm.BioVm.AssociatedZones = data;
                vm.LoadLists();
            });
    }

    vm.GetPlaceListOfCurrentZone = function () {
        HelperService.GetPlaceListOfCurrentZone(vm.ParamZoneId, $rootScope.LangForWork)
            .then(function (data) {
                vm.BioVm.AssociatedPlaceOnSideBarList = data;
                vm.BioVm.AssociatedPlaces = vm.BioVm.AssociatedPlaceOnSideBarList;
                vm.LoadLists();
            });
    }

    //Updoad file - Start
    $scope.informations = {};
    $scope.informations.files = [];
    $scope.openExplorer = function () {
        $timeout(
            function () {
                angular.element('#newupload1').trigger('click');
            }, 0, true
        );
    };
    $scope.addFile = function () {
        var files = angular.element("#fileInfoSource").get(0).files;
        $scope.uploadDragNDrop(files);
    };
    $scope.uploadDragNDrop = function (files) {
        for (var i = 0; i < files.length; i++) {
            var name = files[i].name;

            $scope.informations.files.push(files[i]);
        }
        $scope.$apply();
        $scope.uploadFiles();
    };

    $scope.deleteFile = function (index) {
        $scope.informations.files.splice(index, 1);
    };

    $scope.uploadFiles = function () {
        $scope.files = $scope.informations.files;

        if ($scope.files && $scope.files.length) {
            ExplorerService.UploadFilesForObject($scope.files)
            .then(function (response) {
                $timeout(function () {
                    vm.BioVm.UploadFiles = response.data.Explorer.itemList;
                });
            }, function (response) {
                if (response.status > 0) {
                    $scope.errorMsg = response.status + ': ' + response.data;
                }
            }, function (evt) {
                //$scope.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total)) + "%";
                console.log($scope.progress);
            });
        }
    };
    $scope.refreshUploadList = function (files) {
        $scope.informations.files = files;
        $scope.uploadFiles();
    }
    //Updoad file - End

}